"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapboxMap = require("../../common/mapboxMap");

var _mapboxMap2 = _interopRequireDefault(_mapboxMap);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _mapstylergl = require("../../mapstylergl/mapstylergl");

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _chromaJs = require("chroma-js");

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //     


var Map = function (_Component) {
  _inherits(Map, _Component);

  function Map() {
    _classCallCheck(this, Map);

    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this));

    _this.state = {
      showPanel: false,
      featureInfo: null,
      featureProperties: {},
      layers: {},
      visualizations: {}
    };
    return _this;
  }

  _createClass(Map, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.map = new _mapboxMap2.default(_constants.MAPBOX_ACCESS_TOKEN, {
        style: this.props.vieweroptions.style.url,
        zoom: this.props.vieweroptions.initview.zoom,
        maxZoom: CONSTANTS.MAX_ZOOM,
        bearing: this.props.vieweroptions.initview.bearing,
        pitch: this.props.vieweroptions.initview.pitch,
        center: [this.props.vieweroptions.initview.lon, this.props.vieweroptions.initview.lat],
        attributionControl: false,
        container: this.mapContainer
      });

      this.loadDataGeoJSON(CONSTANTS.URL_SERVER + "/" + this.props.vieweroptions.geojsonpath).then(function (mapData) {
        _this2.props.manageGeojsonData(mapData);
        _this2.initMapData(mapData);
        window.document.getElementsByClassName("mapboxgl-ctrl-logo")[0].style.display = "none";
      }, function (err) {
        console.error("LoadGeojson error: ", err);
        _this2.props.manageGeojsonError();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, nextProps) {
      if (prevProps.vieweroptions.style.url !== this.props.vieweroptions.style.url) {
        this.refreshMap();
      } else if (JSON.stringify(prevProps.vieweroptions.initview) !== JSON.stringify(this.props.vieweroptions.initview)) {
        if (this.map) {
          this.map.resetView(this.props.vieweroptions.initview);
        }
      }
      /*
      else if (JSON.stringify(prevProps.vieweroptions.infowindow.viewfiltersources) !== JSON.stringify(this.props.vieweroptions.infowindow.viewfiltersources)){
              console.info("entro canvi");
              if(this.props.vieweroptions.infowindow.viewfilter == true){
                  console.info("Executos");
              this.checkVisibilityByLayersAndPanel();
              }
          }
          */
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.map.remove();
    }
  }, {
    key: "initMapData",
    value: function initMapData(mapData) {
      var _this3 = this;

      this.map.create().then(function () {
        if (mapData !== null && mapData.features.length > 0) {

          _this3.mapStylerGL = new _mapstylergl.MapStyle(mapData);
          _this3.computeStats(mapData);
          _this3.setData(mapData);
          _this3.map.addControlMap("attribution");
        } else {
          //TODO show Modal de que no hi ha dades
          console.error("Geojson buit");
        }
      });
    }
  }, {
    key: "getCurrentView",
    value: function getCurrentView() {
      var center = this.map.getCenter();
      return {
        zoom: this.map.getZoom(),
        pitch: this.map.getPitch(),
        bearing: this.map.getBearing(),
        lat: center.lat,
        lon: center.lng
      };
    }
  }, {
    key: "checkValuefromField",
    value: function checkValuefromField(item, field) {
      if (field.indexOf(CONSTANTS.CAMP_NOM_PLUJA) !== -1 || field.indexOf(CONSTANTS.CAMP_NOM_NEU) !== -1) {
        if (item === null) {
          //console.info(item);
          item = null;
        }
      }
      // console.info(item);
      return item;
    }
  }, {
    key: "calculateCalValue",
    value: function calculateCalValue(objCalcValuesMaxMin, valuesOBJ, field) {
      // console.log('calculateCalValu,', objCalcValuesMaxMin, valuesOBJ, field)
      var valueMaxMin = {};
      valueMaxMin.max = this.checkValuefromField(valuesOBJ[objCalcValuesMaxMin.valuePosMax], field);
      valueMaxMin.min = this.checkValuefromField(valuesOBJ[objCalcValuesMaxMin.valuePosMin], field);
      var _diff = void 0;
      _diff = (valueMaxMin.max - valueMaxMin.min).toFixed(1);
      _diff = parseFloat(_diff);
      return _diff;
    }
  }, {
    key: "getPositionsTimeStampsArray",
    value: function getPositionsTimeStampsArray(timestamps, calcdatafieldsOptions) {
      var horafiltremax = calcdatafieldsOptions.horafiltremax;
      var horafiltremin = calcdatafieldsOptions.horafiltremin;
      if (horafiltremax === CONSTANTS.OPT_ULTIMAHORA.value) {
        var hours = new Date(timestamps[timestamps.length - 1]).getHours();
        horafiltremax = hours;
        horafiltremin = this.props.timerange.tipus === CONSTANTS.TODAY ? horafiltremin : hours;
      }
      horafiltremax = horafiltremax.length === 1 ? "0" + horafiltremax : horafiltremax;
      horafiltremin = horafiltremin.length === 1 ? "0" + horafiltremin : horafiltremin;
      var formtedMin = _share2.default.formatDateHour(this.props.timerange.timemin + " " + horafiltremin);
      var formtedMax = _share2.default.formatDateHour(this.props.timerange.timemax + " " + horafiltremax);
      var calcValuesMaxMin = {};
      for (var i = 0; i < timestamps.length; i++) {
        var _dateTime = new Date(timestamps[i]);
        var _dateTime2 = _share2.default.formatDateHour(timestamps[i]);
        if (!isNaN(_dateTime.getTime())) {
          if (_dateTime2 == formtedMax) {
            calcValuesMaxMin.dataMax = formtedMax;
            calcValuesMaxMin.valuePosMax = i;
          }
          if (_dateTime2 == formtedMin) {
            calcValuesMaxMin.dataMin = formtedMin;
            calcValuesMaxMin.valuePosMin = i;
          }
        }
      }
      return calcValuesMaxMin;
    }
  }, {
    key: "computeStats",
    value: function computeStats(data) {
      var _this4 = this;

      // console.info("compute ", data);
      this.props.getTimeStamps(data.timestamps);
      var isCalValue = this.props.calcdatafieldsCalculs["_calcvalue"];
      var objCalcValuesMaxMin = isCalValue ? this.getPositionsTimeStampsArray(data.timestamps, this.props.calcdatafieldsOptions) : [];

      var fieldValue = this.props.calcdatafields[0];

      data.features.forEach(function (feature) {

        _this4.props.datafields.forEach(function (field) {

          var min = -1;
          var max = -1;
          var sum = -1;
          var mean = -1;
          var median = -1;
          var calcvalue = -1;
          if (feature.properties[field] !== null && feature.properties[field]) {

            var initValue = void 0;
            var _newValues = void 0;
            var socPluja = void 0;
            var estatsByDay = void 0;
            var values = void 0;
            if (field === 'alt') {
              initValue = feature.properties[fieldValue + "_value"];
              values = Object.values(feature.properties[fieldValue]);

              _newValues = [];
              socPluja = false;
              estatsByDay = {};
            } else {
              initValue = feature.properties[field + "_value"];
              values = Object.values(feature.properties[field]);

              _newValues = [];
              socPluja = false;
              estatsByDay = {};
            }

            // let initValue = feature.properties[`${field}_value`];
            // let values = Object.values(feature.properties[field]);

            // const _newValues = [];
            // let socPluja = false;
            // let estatsByDay = {};


            //let estatsByDayV2 = {};
            if (field.indexOf(CONSTANTS.CAMP_NOM_PLUJA) !== -1 || field.indexOf(CONSTANTS.CAMP_NOM_NEU) !== -1) {
              //  estatsByDay = Share.joinTimesAndValuesPluja(data.timestamps, feature.properties[field]);
              estatsByDay = _share2.default.joinTimesAndValuesPlujaV2(data.timestamps, feature.properties[field], initValue);
              if (estatsByDay.needReset) {
                initValue = 0;
                feature.properties[field + "_value"] = initValue;
              }
              socPluja = true;
              values.forEach(function (item) {
                if (item === null) {
                  item = 0;
                }
                _newValues.push(item);
              });
              values = _newValues;
            } else {
              values = values.filter(function (value) {
                return value !== null && !Number.isNaN(value);
              });
            }
            // let fieldValue
            var minValue = void 0;
            var maxValue = void 0;

            if (_this4.props.calcdatafields.length === 1 || _this4.props.calcdatafields.length === 2 && _this4.props.calcdatafields.includes('alt')) {

              values = values.filter(function (values) {
                return values >= _this4.props.calcdatafieldsOptions.rang.min;
              });
              minValue = _this4.props.calcdatafieldsOptions.rang.min;

              values = values.filter(function (values) {
                return values <= _this4.props.calcdatafieldsOptions.rang.max;
              });
              maxValue = _this4.props.calcdatafieldsOptions.rang.max;

              feature.properties[field + "_value"] = initValue >= _this4.props.calcdatafieldsOptions.rang.min && initValue <= _this4.props.calcdatafieldsOptions.rang.max ? initValue : null;

              // }else{
              // feature.properties[`${field}_value`] =
              // initValue >= this.props.calcdatafieldsOptions.rang.min &&
              // initValue <= this.props.calcdatafieldsOptions.rang.max
              //   ? initValue
              //   : null;


              // }


              // values = values.filter(
              //   values => values >= this.props.calcdatafieldsOptions.rang.min
              // );
              // values = values.filter(
              //   values => values <= this.props.calcdatafieldsOptions.rang.max
              // );

              // feature.properties[`${field}_value`] =
              //   initValue >= this.props.calcdatafieldsOptions.rang.min &&
              //   initValue <= this.props.calcdatafieldsOptions.rang.max
              //     ? initValue
              //     : null;
            }

            var arrayStats = new _mapstylergl.ArrayStatics(values);

            var estats = arrayStats.getBasicsStats(1);

            min = estats.basics.min;
            max = estats.basics.max;
            if (socPluja) {
              values = values.filter(function (values) {
                return values > 0;
              });
              arrayStats = new _mapstylergl.ArrayStatics(values);
              estats = arrayStats.getBasicsStats(1);
              //min = estats.basics.min;
              //max = estats.basics.max;
              min = estatsByDay.min;
              max = estatsByDay.max;
              //min = (estatsByDay.min >= this.props.calcdatafieldsOptions.rang.min && estatsByDay.min <= this.props.calcdatafieldsOptions.rang.max) ? estatsByDay.min : null;
              //max = (estatsByDay.max >= this.props.calcdatafieldsOptions.rang.min && estatsByDay.max <= this.props.calcdatafieldsOptions.rang.max) ? estatsByDay.max : null;
              if (_this4.props.calcdatafields.length === 1) {
                min = estatsByDay.min >= _this4.props.calcdatafieldsOptions.rang.min && estatsByDay.min <= _this4.props.calcdatafieldsOptions.rang.max ? estatsByDay.min : null;
                max = estatsByDay.max >= _this4.props.calcdatafieldsOptions.rang.min && estatsByDay.max <= _this4.props.calcdatafieldsOptions.rang.max ? estatsByDay.max : null;
                sum = estatsByDay.sum >= _this4.props.calcdatafieldsOptions.rang.min && estatsByDay.sum <= _this4.props.calcdatafieldsOptions.rang.max ? estatsByDay.sum : null;
                mean = estatsByDay.mean >= _this4.props.calcdatafieldsOptions.rang.min && estatsByDay.mean <= _this4.props.calcdatafieldsOptions.rang.max ? estatsByDay.mean : null;
              } else {
                min = estatsByDay.min;
                max = estatsByDay.max;
                sum = estatsByDay.sum;
                mean = estatsByDay.mean;
              }
            } else {
              //sum = estats.basics.sum;
              //mean = estats.basics.mean;
              if (_this4.props.calcdatafields.length === 1 || _this4.props.calcdatafields.length === 2 && _this4.props.calcdatafields.includes('alt')) {

                min = estats.basics.min >= _this4.props.calcdatafieldsOptions.rang.min && estats.basics.min <= _this4.props.calcdatafieldsOptions.rang.max ? estats.basics.min : null;
                max = estats.basics.max >= _this4.props.calcdatafieldsOptions.rang.min && estats.basics.max <= _this4.props.calcdatafieldsOptions.rang.max ? estats.basics.max : null;
                sum = estats.basics.sum >= _this4.props.calcdatafieldsOptions.rang.min && estats.basics.sum <= _this4.props.calcdatafieldsOptions.rang.max ? estats.basics.sum : null;
                mean = estats.basics.mean >= _this4.props.calcdatafieldsOptions.rang.min && estats.basics.mean <= _this4.props.calcdatafieldsOptions.rang.max ? estats.basics.mean : null;
              } else {
                min = estats.basics.min;
                max = estats.basics.max;
                sum = estats.basics.sum;
                mean = estats.basics.mean;
              }
            }
            median = estats.basics.median;
            calcvalue = isCalValue ? _this4.calculateCalValue(objCalcValuesMaxMin, feature.properties[field], field) : estats.basics.diff;
          }

          feature.properties[field + "_min"] = min;
          feature.properties[field + "_max"] = max;
          feature.properties[field + "_sum"] = sum;
          feature.properties[field + "_mean"] = mean;
          feature.properties[field + "_median"] = median;
          feature.properties[field + "_calcvalue"] = calcvalue;

          var alt = feature.properties['alt'];

          var altValue = alt[Object.keys(alt)[0]];

          feature.properties['alt_max'] = altValue;
          feature.properties['alt_min'] = altValue;

          // if (feature.properties.nomok.indexOf("Olot") !== -1) {
          //     console.info(feature.properties);
          // }
        });
      });
    }
  }, {
    key: "loadDataGeoJSON",
    value: function loadDataGeoJSON(urlGeoJson) {
      return new Promise(function (resolve, reject) {
        _request2.default.get(urlGeoJson).then(function (data) {
          return resolve(data);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      var _this5 = this;

      this.map.setMapBaseLayer(this.props.vieweroptions.style.url).then(function () {
        _this5.loadDataGeoJSON(CONSTANTS.URL_SERVER + "/" + _this5.props.vieweroptions.geojsonpath).then(function (mapData) {
          _this5.mapStylerGL = new _mapstylergl.MapStyle(mapData);
          _this5.computeStats(mapData);
          _this5.setData(mapData);
        }).catch(function (err) {
          //(mapData) => this.setData(mapData),
          //(mapData) => this.computeStats(mapData),
          //(err)=> console.error("LoadGeojson error: ", err)
          console.error("LoadGeojson error: ", err);
        });
      });
    }
  }, {
    key: "checkNameField",
    value: function checkNameField(field) {
      if (field.indexOf("_value") === -1) {
        field = field + "_value";
      }
      return field;
    }
  }, {
    key: "createLayersFromTematicOptions",
    value: function createLayersFromTematicOptions(thematicOptions) {
      var _this6 = this;

      var layersArray = [];
      thematicOptions.forEach(function (visualitzacio) {
        layersArray.push(_this6.createLayerByVisualization(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, _this6.checkNameField(visualitzacio.field), visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].type));
        layersArray.push(_this6.createLayerByVisualization(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, _this6.checkNameField(visualitzacio.field), visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].type));
      });
      return layersArray;
    }
  }, {
    key: "createLayersFromVisualitzacio",
    value: function createLayersFromVisualitzacio(visualitzacio) {
      this.map.addLayer(this.createLayerByVisualization(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, this.checkNameField(visualitzacio.field), visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].type));
      this.map.addLayer(this.createLayerByVisualization(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, this.checkNameField(visualitzacio.field), visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].type));
    }
  }, {
    key: "setData",
    value: function setData(data) {
      var _this7 = this;

      // console.log('data', data)
      this.map.setData({

        layers: this.createLayersFromTematicOptions(this.props.vieweroptions.thematicoptions),
        sources: [{
          name: CONSTANTS.SOURCE_MAIN,
          data: {
            type: "geojson",
            data: data
          }
        }]
      });
      this.props.vieweroptions.thematicoptions.forEach(function (visualitzacio, indexVis) {
        _this7.updateVisualitzacioLayers(visualitzacio, indexVis);
      });
    }
  }, {
    key: "removeVisualizationFromIndex",
    value: function removeVisualizationFromIndex(id) {
      this.removeVisualizationLayer("" + id + CONSTANTS.DEFAULT_INDEX_SUFFIX_POL);
      this.removeVisualizationLayer("" + id + CONSTANTS.DEFAULT_INDEX_SUFFIX_TEXT);
    }
  }, {
    key: "removeVisualizationLayer",
    value: function removeVisualizationLayer(layerId) {
      this.map.removeLayer(layerId);
    }
  }, {
    key: "updateLayersVisibilityOfVisualitzacio",
    value: function updateLayersVisibilityOfVisualitzacio(vis, isVisible, indexVis) {
      if (isVisible) {
        this.map.setLayoutProperty(vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, "visibility", vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].visibility ? "visible" : "none");
        this.map.setLayoutProperty(vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, "visibility", vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].visibility ? "visible" : "none");
        this.props.updateLayerStyle(this.map.getPaintProperty(vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, "fill-extrusion-color"), indexVis);
      } else {
        this.map.setLayoutProperty(vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, "visibility", "none");
        this.map.setLayoutProperty(vis.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, "visibility", "none");
      }
    }
  }, {
    key: "checkVisibilityByLayersAndPanel",
    value: function checkVisibilityByLayersAndPanel() {
      var _this8 = this;

      this.props.vieweroptions.thematicoptions.forEach(function (visualitzacio, index) {
        //this.updateLayersVisibilityFromVisualitzacio(indexVis, visualitzacio.isVisible);
        if (visualitzacio.isVisible) {
          _this8.map.setLayoutProperty(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, "visibility", visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].visibility ? "visible" : "none");
          _this8.map.setLayoutProperty(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, "visibility", visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].visibility ? "visible" : "none");
          _this8.props.updateLayerStyle(_this8.map.getPaintProperty(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, "fill-extrusion-color"), index);
        } else {
          _this8.map.setLayoutProperty(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, "visibility", "none");
          _this8.map.setLayoutProperty(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, "visibility", "none");
        }
      });
    }
  }, {
    key: "createLayerByVisualization",
    value: function createLayerByVisualization(layerId, _fieldName, layerType) {
      var fieldName = "" + _fieldName;
      var layer = this.mapStylerGL.createStyleLayer(CONSTANTS.SOURCE_MAIN, layerId, fieldName, layerType, 18, 4);

      this.subscribeEventsToLayers(layerId);
      return layer.style;
    }
  }, {
    key: "setActionOnClick",
    value: function setActionOnClick(feature) {
      //console.info(feature);
      this.props.getFeatureInfo(feature);
    }
  }, {
    key: "subscribeEventsToLayers",
    value: function subscribeEventsToLayers(layerId) {
      var _this9 = this;

      this.map.subscribe("click", layerId, function (e) {
        var feature = e.features[0];
        _this9.setActionOnClick(feature);
      });
      this.map.subscribe("mousemove", layerId, function (e) {
        _this9.map.setCursorPointer("pointer");
        var feature = e.features[0];
        _this9.setState({
          featureProperties: feature.properties,
          showPanel: true
        });
      });
      this.map.subscribe("mouseleave", layerId, function () {
        return _this9.map.setCursorPointer("");
      });
    }
  }, {
    key: "updateFieldTextValue",
    value: function updateFieldTextValue(layerId, fieldName) {

      if (fieldName.includes('alt')) {
        // console.log('layer', layerId, fieldName)
        fieldName = 'alt_max';

        this.map.setLayoutProperty(layerId, "text-field", "{" + fieldName + "}");
      } else {
        this.map.setLayoutProperty(layerId, "text-field", "{" + fieldName + "}");
      }
    }
  }, {
    key: "setBadges",
    value: function setBadges(layerId, factor, fieldName, colorrangs, rangs) {
      if (factor) {
        var styleBadges = _share2.default.styleBadgesFromStylesColor(this.mapStylerGL.setStylesPaintFromColorArray(fieldName, CONSTANTS.LARGE_SCALE));
        this.map.setLayoutProperty(layerId, "icon-image", styleBadges);
        this.map.setLayoutProperty(layerId, "icon-size", 1);
        this.map.setLayoutProperty(layerId, "icon-text-fit", "both");
        this.map.setLayoutProperty(layerId, "icon-text-fit-padding", [6, 8, 6, 8]);
        this.map.setLayoutProperty(layerId, "icon-rotation-alignment", "viewport");
        this.map.setLayoutProperty(layerId, "icon-anchor", "center");
        this.map.setLayoutProperty(layerId, "icon-padding", 15);
        this.map.setLayoutProperty(layerId, "icon-allow-overlap", true);
        //this.map.setPaintProperty(layerId, "text-color", "#ffffff");
        this.map.setPaintProperty(layerId, "icon-opacity", 1);
        //	this.map.setPaintProperty(layerId, "text-halo-color", "#000000");
        this.map.setPaintProperty(layerId, "text-halo-blur", 1);
        this.map.setPaintProperty(layerId, "text-halo-width", 2.5);
      } else {
        this.map.setLayoutProperty(layerId, "icon-image", "none");
        this.map.setLayoutProperty(layerId, "icon-size", 0);
        this.map.setPaintProperty(layerId, "text-halo-blur", 1);
        this.map.setPaintProperty(layerId, "text-halo-width", 2.5);
        if (rangs) {
          var numi = colorrangs && colorrangs.colorscale && colorrangs.colorscale.length ? colorrangs.colorscale.length : colorrangs.length;
          var rangColors = _chromaJs2.default.scale(["#000000", "#0f0f0f"]).colors(numi);
          var fixBetterHaloColor = _share2.default.styleBetterRampFromStylesColor(this.mapStylerGL.setStylesPaintFromColorArray(fieldName, rangColors));
          this.map.setPaintProperty(layerId, "text-halo-color", fixBetterHaloColor);
        }
      }
    }
  }, {
    key: "updateLayerStyle",
    value: function updateLayerStyle(layerId, fieldName, colorrangs, paintProperty, factor) {
      // console.info("updateLayerStyle", paintProperty);
      if (paintProperty.indexOf("extrusion-height") === -1) {
        if (colorrangs && (colorrangs.colorscaleType || "rangs") === "predefinits" && paintProperty.indexOf("text-size") === -1) {
          if (paintProperty.indexOf("text-halo-color") === -1) {
            if (paintProperty === "text-size") {
              this.map.setLayoutProperty(layerId, "text-size", this.mapStylerGL.setStyleTextSizeByFactorSize(factor));
            } else if (paintProperty === "text-font") {
              this.map.setLayoutProperty(layerId, "text-font", [factor]);
            } else if (paintProperty !== "icon-image") {
              this.map.setPaintProperty(layerId, paintProperty, this.mapStylerGL.setStylesFromPredefinedScales(fieldName, colorrangs.label || ""));
            } else if (paintProperty === "icon-image") {
              this.setBadges(layerId, factor, fieldName, colorrangs, false);
            }
          }
        } else {
          if (paintProperty === "text-size") {
            this.map.setLayoutProperty(layerId, "text-size", this.mapStylerGL.setStyleTextSizeByFactorSize(factor));
          } else if (paintProperty === "text-font") {
            this.map.setLayoutProperty(layerId, "text-font", [factor]);
          } else if (paintProperty === "icon-image") {
            this.setBadges(layerId, factor, fieldName, colorrangs, true);
          } else {
            var rangColors = void 0;
            if (colorrangs && colorrangs.colorscale && colorrangs.colorscale.length) {
              rangColors = paintProperty === "text-halo-color" ? _chromaJs2.default.scale(["#000000", "#0f0f0f"]).colors(colorrangs.colorscale.length) : colorrangs.colorscale;
            } else {
              rangColors = colorrangs;
            }
            //console.info("passoper aqui",this.mapStylerGL.setStylesPaintFromColorArray(fieldName, rangColors));
            var fixBetterRampColor = _share2.default.styleBetterRampFromStylesColor(this.mapStylerGL.setStylesPaintFromColorArray(fieldName, rangColors));
            this.map.setPaintProperty(layerId, paintProperty, fixBetterRampColor);
          }
        }
      } else {
        var res = this.mapStylerGL.setStylebyFactorHeights(fieldName, factor);
        this.map.setPaintProperty(layerId, paintProperty, res);
      }
      if (fieldName.indexOf("pluja") === -1) {
        if (this.props.vieweroptions.infowindow.viewfilter == true && this.props.vieweroptions.infowindow.viewfiltersources && this.props.vieweroptions.infowindow.viewfiltersources.length > 0) {
          var filter = ["all", ["in", ["get", "font"], ["literal", this.props.vieweroptions.infowindow.viewfiltersources]], ["!=", ["typeof", ["get", fieldName]], "null"]];
          this.map.setFilter(layerId, filter);
        } else {
          this.map.setFilter(layerId, ["!=", ["typeof", ["get", fieldName]], "null"]);
        }
      } else {
        if (this.props.vieweroptions.infowindow.viewfilter == true && this.props.vieweroptions.infowindow.viewfiltersources && this.props.vieweroptions.infowindow.viewfiltersources.length > 0) {
          var _filter = ["all", ["in", ["get", "font"], ["literal", this.props.vieweroptions.infowindow.viewfiltersources]], ["!=", fieldName, "null"], [">", fieldName, 0]];

          this.map.setFilter(layerId, _filter);
        } else {
          this.map.setFilter(layerId, ["all", ["!=", fieldName, "null"], [">", fieldName, 0]]);
        }
      }
    }
  }, {
    key: "setFiltersToLayers",
    value: function setFiltersToLayers(filters) {
      //console.info("filters",this.props.vieweroptions.infowindow.viewfiltersources);
      //console.info("filters",this.props.vieweroptions);
      /*
          var filter=["all",
          ['in', ['get','font'],["literal",['meteosona','OpenWeather']]],
          ["!=", ["typeof", ["get", "temp_value"]], "null"]
          ];
          */
      this.props.vieweroptions.thematicoptions.forEach(function (visualitzacio, index) {
        //console.info("acpes",visualitzacio.layers[index]);
        //console.info("acpes",visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name);
      });
    }
  }, {
    key: "updateVisualitzacio",
    value: function updateVisualitzacio(visualitzacio) {
      // console.log('XXXXX', visualitzacio)
      var fieldName = "" + visualitzacio.field + visualitzacio.fieldvalue || "temp_value";
      // console.log('LAYERFIELDAME', fieldName)


      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, fieldName, visualitzacio.colorrangs, "fill-extrusion-height", visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].extrussion);
      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].name, fieldName, visualitzacio.colorrangs, "fill-extrusion-color");
      this.updateFieldTextValue(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, fieldName);
      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, fieldName, visualitzacio.colorrangs, "text-color");
      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, fieldName, visualitzacio.colorrangs, "text-halo-color");
      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, fieldName, visualitzacio.colorrangs, "text-size", visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontsize);
      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, fieldName, visualitzacio.colorrangs, "text-font", visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontname);
      this.updateLayerStyle(visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].name, fieldName, visualitzacio.colorrangs, "icon-image", visualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].badge);
    }
  }, {
    key: "addNewVisualitzacioLayers",
    value: function addNewVisualitzacioLayers(newVis, index) {
      this.createLayersFromVisualitzacio(newVis);
      this.updateVisualitzacioLayers(newVis, index);
    }
  }, {
    key: "updateVisualitzacioLayers",
    value: function updateVisualitzacioLayers(visualitzacio, indexVis) {
      //console.info(visualitzacio);
      var fieldName = "" + visualitzacio.field + visualitzacio.fieldvalue || "temp_value";
      this.mapStylerGL.generateGeoStatisticsFromField(fieldName); //TODO Check if this is needed really needed
      this.updateVisualitzacio(visualitzacio);
      this.updateLayersVisibilityOfVisualitzacio(visualitzacio, visualitzacio.isVisible, indexVis);
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var style = { width: "100%", height: "100%" };
      return _react2.default.createElement("div", { ref: function ref(el) {
          return _this10.mapContainer = el;
        }, style: style });
    }
  }]);

  return Map;
}(_react.Component);

exports.default = Map;

Map.propTypes = {
  vieweroptions: _propTypes2.default.object,
  datafields: _propTypes2.default.array,
  calcdatafields: _propTypes2.default.array,
  calcdatafieldsCalculs: _propTypes2.default.object,
  calcdatafieldsOptions: _propTypes2.default.object,
  panelindex: _propTypes2.default.number,
  layers: _propTypes2.default.object,
  getFeatureInfo: _propTypes2.default.func,
  getTimeStamps: _propTypes2.default.func,
  getTimeStampsCalcValue: _propTypes2.default.func,
  updateLayerStyle: _propTypes2.default.func,
  timerange: _propTypes2.default.object,
  manageGeojsonError: _propTypes2.default.func,
  manageGeojsonData: _propTypes2.default.func
};
